const rankingItems = [
  { rank: 1, title: '鬼灭之刃 柱训练篇', heat: '128万', change: 'up', tag: '热播中' },
  { rank: 2, title: '葬送的芙莉莲', heat: '112万', change: 'up', tag: '高分推荐' },
  { rank: 3, title: '怪兽8号', heat: '96万', change: 'up', tag: '人气新番' },
  { rank: 4, title: '我推的孩子 第二季', heat: '89万', change: 'down', tag: '热播中' },
  { rank: 5, title: '咒术回战 第二季', heat: '82万', change: 'same', tag: '经典回顾' },
  { rank: 6, title: '防风少年', heat: '73万', change: 'up', tag: '热血校园' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            本周动漫在线观看热度排行，看看大家都在追什么番
          </p>
        </div>
        <div className="bg-background-100 border border-background-200/70 rounded-lg overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-primary-300 text-white'
                  : item.rank === 3
                  ? 'bg-primary-200 text-primary-800'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                <span className="text-sm font-bold">{item.rank}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">
                    {item.title}
                  </span>
                  <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <div className="w-4 h-4 flex items-center justify-center">
                  {item.change === 'up' ? (
                    <i className="ri-arrow-up-fill text-xs text-primary-500"></i>
                  ) : item.change === 'down' ? (
                    <i className="ri-arrow-down-fill text-xs text-foreground-400"></i>
                  ) : (
                    <i className="ri-subtract-line text-xs text-foreground-400"></i>
                  )}
                </div>
                <span className="text-xs md:text-sm text-foreground-600 font-medium whitespace-nowrap">
                  {item.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}